// export const HEADER_ENVIRONMENT = 'ApiVersion';
// Old Header
export const HEADER_INSTALLATION_ID = 'X-Device-Id';
// New Header
export const HEADER_CLIENT_ID = 'clientId';
export const HEADER_AUTH_TOKEN = 'X-Auth-Token';
export const HEADER_AUTH_TOKEN_AWS = 'Vf-A-Appbusinessauth';
export const HEADER_DOMAIN = 'domain';
// Internal header
export const HEADER_API = 'X-Bwb-API';
export const HEADER_NO_LOADER = 'X-Bwb-No-Loader';
// Internal header -- AWS
export const HEADER_AWS_API = 'Aws-API';

// Last app version of the v1. From v2 api.sim.details will be called in POST.
export const V1_LAST_VERSION = '12.1.99';
// Others
export const HEADER_DEVICE_UA = 'X-Device-User-Agent';
export const HEADER_NETWORK_INFO = 'X-Network-Info';
// dxl auth header
export const HEADER_AUTH = 'Authorization';
// Cookie
export const COOKIE_SESSION = 'bwb-myvf-sess';
export const COOKIE_DEV = 'myvf-dev';
export const COOKIE_OBSSO = 'ObSSOCookie';

// Client ID
export const CLIENT_ID = '6002';
// Domain
export const DOMAIN = 'enterprise';
// dxl auth header value
// TODO per TEST --> export const AUTH_VALUE = 'Basic QnVzQmVld2VlYjo4MTdGNzVDRTFDNDlEMkM1M0RGRUNCQTY5NkQ2MzRGNzkxREExNzlG';
export const AUTH_VALUE = 'Basic QnVzQmVld2VlYjplMGQzY2U5YTA5MWZlNjViOGFiZWI3Y2EwNDM5MjY1NTYyZTEzMTI0';
